import { render, staticRenderFns } from "./CustomOfficialEvents.vue?vue&type=template&id=8354157e&scoped=true"
import script from "./CustomOfficialEvents.vue?vue&type=script&lang=js"
export * from "./CustomOfficialEvents.vue?vue&type=script&lang=js"
import style0 from "./CustomOfficialEvents.vue?vue&type=style&index=0&id=8354157e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8354157e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/.jenkins/workspace/web-ug-admin-dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8354157e')) {
      api.createRecord('8354157e', component.options)
    } else {
      api.reload('8354157e', component.options)
    }
    module.hot.accept("./CustomOfficialEvents.vue?vue&type=template&id=8354157e&scoped=true", function () {
      api.rerender('8354157e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/operationManagement/aggregatePageManagement/components/CustomOfficialEvents.vue"
export default component.exports